import axios from 'axios'
import { getToken, logout } from '../guard'

const http = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/v1`,
  timeout: 15000, // 15 seconds timeout
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

http.interceptors.request.use(async (config) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  console.error('Request error:', error)
  return Promise.reject(error)
})

http.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response) {
      const {
        data: { message },
        status
      } = error.response
      
      if (message === 'User not found' || status === 401) {
        logout()
        window.location.href = '/login'
      }
      
      // Log detailed error information
      console.error(`API Error (${status}):`, message || 'Unknown error')
    } else if (error.request) {
      console.error('No response received:', error.request)
    } else {
      console.error('Error setting up request:', error.message)
    }

    return Promise.reject(error)
  }
)

export default http
